type AppBadgingNavigator = Navigator & {
  clearAppBadge?: () => Promise<void>;
  setAppBadge?: (contents?: number) => Promise<void>;
};

const getBadgingNavigator = (): AppBadgingNavigator | null => {
  if (typeof navigator === "undefined") {
    return null;
  }

  return navigator as AppBadgingNavigator;
};

export const isAppBadgingSupported = (): boolean => {
  const badgingNavigator = getBadgingNavigator();
  return typeof badgingNavigator?.setAppBadge === "function"
    && typeof badgingNavigator.clearAppBadge === "function";
};

export const updateAppBadge = async (count: number): Promise<void> => {
  const badgingNavigator = getBadgingNavigator();
  if (
    typeof badgingNavigator?.setAppBadge !== "function"
    || typeof badgingNavigator.clearAppBadge !== "function"
  ) {
    return;
  }

  try {
    if (count > 0) {
      await badgingNavigator.setAppBadge(count);
      return;
    }

    await badgingNavigator.clearAppBadge();
  } catch {
    // Browsers can reject badge updates outside supported installed-app contexts.
  }
};
